import { DATA_TABLE_BLANK_FILTER_VALUE } from '@/lib/dynamic-filters';
import type { DataTableRenderCellParams } from './types';

export const getRowContextFilterLabel = (value: unknown) => {
  const normalizedValue = value === DATA_TABLE_BLANK_FILTER_VALUE || value == null ? '' : String(value).trim();
  const displayValue = normalizedValue || 'Trống';
  const compactValue = displayValue.length > 28 ? `${displayValue.slice(0, 28)}…` : displayValue;

  return `Lọc (${compactValue})`;
};

const formatDateFilterValue = (value: unknown) => {
  const stringValue = String(value ?? '').trim();
  const displayDateMatch = stringValue.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (displayDateMatch) {
    return `${displayDateMatch[1]}/${displayDateMatch[2]}/${displayDateMatch[3]}`;
  }

  const isoDateMatch = stringValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDateMatch) {
    return `${isoDateMatch[3]}/${isoDateMatch[2]}/${isoDateMatch[1]}`;
  }

  const compactDateMatch = stringValue.match(/^(\d{4})(\d{2})(\d{2})$/);
  if (compactDateMatch) {
    return `${compactDateMatch[3]}/${compactDateMatch[2]}/${compactDateMatch[1]}`;
  }

  const dateValue = value instanceof Date ? value : new Date(stringValue);
  if (Number.isNaN(dateValue.getTime())) return stringValue;

  const day = String(dateValue.getDate()).padStart(2, '0');
  const month = String(dateValue.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${dateValue.getFullYear()}`;
};

export const getRowContextFilterValue = (cell: DataTableRenderCellParams) => {
  if (cell.value == null || String(cell.value).trim() === '') {
    return DATA_TABLE_BLANK_FILTER_VALUE;
  }

  const isDateColumn = cell.colDef.type === 'date' || cell.colDef.type === 'dateTime' || cell.field.startsWith('ngay_');
  if (!isDateColumn) return String(cell.value);

  const formattedValue = formatDateFilterValue(cell.formattedValue);
  return formattedValue || formatDateFilterValue(cell.value);
};
